import { CreateStyled } from '@emotion/styled';

/**
 * Adds transient props support for styled components
 * to prevent setting incompatible props for elements.
 *
 * Usage:
 * export const MyStyledDiv = styled(div, transientProps)<{ $isCustomProp: boolean }>(({ theme, $isCustomProp }) => ({
 *     color: $isCustomProp ? 'white' : 'black'
 *   }))
 */
export const transientProps: Parameters<CreateStyled>[1] = {
  shouldForwardProp: (propName: string) => !propName.startsWith('$'),
};
